define('app/filters/sumOfValue',['angular', 'app/services/shared', 'app/util/BitArray'], function (angular) {
  var module = angular.module('app.filters', ['app.shared']);

  function toHHMM(min, relative, zeroMin) {
    var prefix = '';

    if (relative) {
      min += zeroMin;
      if(min < 1440) {
        prefix = '-';
      }
      else if(min <= 2880) {
        min -= 1440;
      } else {
        min -= 2880;
        prefix = '+';
      }
    }

    var minStr = ("0" + (min % 60)).slice(-2);
    var hourStr = ("0" + (Math.floor(min/60))).slice(-2);

    return prefix + hourStr + ':' + minStr;
  }

  function totalMinutes(minutes, pre, pos) {
    if(minutes == 0)
      return "";

    var hr = Math.floor(minutes/60);
    var mi = minutes % 60;

    if(!pre) pre = "";

    if (hr > 0)
      pre += hr + "h";

    if (mi > 0) {
      if (hr > 0)
        pre += " ";
      pre += ("00" + mi).slice(-2) + "min";
    }

    if(!pos) pos = "";

    return pre + pos;
  }

  module.filter('totz', function () {
	  return function (input) {
		  var min = Math.abs(Math.floor(input/60));
		  var prefix = input < 0 ? '-' : '+';
		  //console.log(input, prefix, min);
  
		  var minStr = ("0" + (min % 60)).slice(-2);
		  var hourStr = ("0" + (Math.floor(min/60))).slice(-2);
		  return prefix + hourStr + ':' + minStr;
	  };
    });

	module.filter('toHex', function () {
	  return function (input, sz) {
		  // console.log(input, sz);
		  if (!input) return '';
		  if (!sz) sz = 8;
		  var tmp = '00000000' + (Number(input).toString(16)).toUpperCase();
		  return '0x'+tmp.substr(tmp.length - sz);
	  };
    });
  

  module.filter('joinBy', function () {
	  return function (input,prop,delimiter) {
		  return (input || []).map(function(currVal, ndx, arr) {return currVal[prop]}).join(delimiter || ', ');
	  };
    });
	
  module.filter('joinArray', function () {
	  return function (input,delimiter) {
		  return (input || []).join(delimiter || ', ');
	  };
    });
	
  module.filter('hhmmranges', function () {
    return function doit (input) {
      var ba = BitArray.Parse64(input);

      var minutes = ba.getNumberOfUnos();
      if (minutes == 0) return "";

      var nb = ba.getNumberOfBloques();
      var ss = '';
      for(var i=0; i<nb; i++){
        var iniFin = ba.getBloque(i);
        ss += ((i==0?'':', ') + toHHMM(iniFin[0], true, 0) + '-' + toHHMM(iniFin[1], true, 0));
      }

      return totalMinutes(minutes, '(', ') ') + ss
    }
  });

  module.filter('hhmm', function () {
    return function doit (min) {
      return toHHMM(min, true, 1440)
    }
  });

  module.filter('hhmmabs', function () {
    return function doit (min) {
      return toHHMM(min, false, 0)
    }
  });

  module.filter('todate', ['$filter', function ($filter) {
	  return function(min, format, timezone) {
		  var dt = new Date(1970,0,(min+1));
		  if (format === undefined)
			  return dt;
		  return $filter('date')(dt, format, timezone);
	  };
  }]);
  
  
  module.filter('mycurrency', ['$filter', function ($filter) {
	  return function(amount, currencySymbol, fractionSize) {
		  
		  switch(currencySymbol)
		  {
			  case 'EUR':
				currencySymbol = '€';
				break;
			case 'USD':
				currencySymbol = '$';
				break;
			case 'GBP':
				currencySymbol = '‎£';
				break;
		  }
		  return $filter('currency')(amount, currencySymbol, fractionSize);
	  };
  }]);

  module.filter('nomRaosocial', function () {
    return function doit (value) {
      if (!value)
        return '';
      if (!value.Nom && !value.Cognoms)
        return value.RaoSocial;
      else if (!value.RaoSocial)
        return value.Cognoms + ', ' + value.Nom;
      else
        return value.Cognoms + ', ' + value.Nom + ' (' + value.RaoSocial + ')';
    }
  });

  module.filter('nomFinca', function () {
    return function doit (finca) {
      if (!finca || !finca.Propietari)
        return '';
      var value = finca.Propietari;

      if (!value.Nom && !value.Cognoms)
        return finca.Adreca + ' - ' + value.RaoSocial;
      else if (!value.RaoSocial)
        return finca.Adreca + ' - ' + value.Cognoms + ', ' + value.Nom;
      else
        return finca.Adreca + ' - ' + value.Cognoms + ', ' + value.Nom + ' (' + value.RaoSocial + ')';
    }
  });

  module.filter('checkmark', function () {
    return function getCheckmark (input) {
      return input ? '\u2713' : '\u2718'
    }
  });

  module.filter('sumOf', function () {
    return function (data, key) {
      if (angular.isUndefined(data) || angular.isUndefined(key)) {
        return 0
      }

      var sum = 0;
      angular.forEach(data, function (value) {
        sum += value[key]
      });

      return sum
    }
  });

  module.filter('sumOfProduct', function () {
    return function (data, key1, key2) {
      if (angular.isUndefined(data) || angular.isUndefined(key1) || angular.isUndefined(key2)) {
        return 0
      }

      var sum = 0;
      angular.forEach(data, function (value) {
        sum += (value[key1] * value[key2])
      });

      return sum
    }
  });

  module.filter('numberFixedLen', function () {
    return function (n, len) {
      var num = parseInt(n, 10);
      len = parseInt(len, 10);
      if (isNaN(num) || isNaN(len)) {
        return n
      }
      num = '' + num;
      while (num.length < len) {
        num = '0' + num
      }
      return num
    }
  });

  module.filter('isEmpty', function () {
    var bar;
    return function (obj) {
      for (bar in obj) {
        if (obj.hasOwnProperty(bar)) {
          return false
        }
      }
      return true
    }
  });

  module.filter('arrContains', function () {
    return function (input, key, id) {
      var retArr = [];
      for (var i = 0; i < input.length; i++) {
        var el = input[i];
        if (el.hasOwnProperty(key)) {
          var ids = el[key];
          for (var ii = 0; ii < ids.length; ii++) {
            if (ids[ii] === id) {
              // console.log('found')
              retArr.push(el);
              break
            }
          }
        } else {
          retArr.push(input[i])
        }
      }
      return retArr
    }
  });

  module.filter('actionEnabled', function () {
    return function (input, name, id) {
      var retArr = [];
      for (var i = 0; i < input.length; i++) {
        var act = input[i];
        if (act.id === name) {
          if (act.enablePolicy === 'allways') {
            return act.active //true
          } else if (act.enablePolicy === 'never') {
            return false
          } else if (act.enablePolicy === 'perItem') {
            if (!act.hasOwnProperty('ids')) {
              return false
            }
            var ids = act.ids;
            for (var ii = 0; ii < ids.length; i++) {
              if ((act.isInt && parseInt(ids[ii]) === parseInt(id)) || (!act.isInt && ids[ii] === id)) {
                return act.active //true
              }
            }
            return false;
          }
          return false;
        }
      }
      return false
    }
  });

  return module
});

